export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const GET_USER = 'GET_USER'
export const GET_PAGE_CLASS = 'GET_PAGE_CLASS'
export const GET_CITIES = 'GET_CITIES'
export const SHOW_PRELOADER = 'SHOW_PRELOADER'
export const SHOW_MENU = 'SHOW_MENU'
export const GET_GENERAL_SETTINGS = 'GET_GENERAL_SETTINGS'
export const GET_CITY_DETAILS = 'GET_CITY_DETAILS'
export const GET_UNIVERSITY_DETAILS = 'GET_UNIVERSITY_DETAILS'
export const SET_ACTOR_MOVIES = 'SET_ACTOR_MOVIES'
export const SET_MOBILE_MENU_ACTIVE = 'SET_MOBILE_MENU_ACTIVE'
export const SET_LOGIN1 = 'SET_LOGIN1'
export const SET_USER_INFO1 = 'SET_USER_INFO1'